import React, { useState } from 'react';
import { FlexAround } from '../../../../../../styles/stylesStyled';
import { useSelector } from 'react-redux';
import { ZeroLevelInfo } from './ZeroLevelInfo';
import {
  GoLeftDownArrowButton,
  GoRightDownArrowButton,
  GoUpArrowButton,
  LevelOne
} from '../../../common';

export const LevelZero = () => {
  const { rootTeamMember } = useSelector((store) => store.myTeamBackoffice);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <FlexAround>
        <div>
          <GoUpArrowButton />
          <GoLeftDownArrowButton />
        </div>
        <div onClick={() => setIsOpen(!isOpen)} style={{ display: 'flex' }}>
          <LevelOne teamMember={rootTeamMember} />

          {/* <UserComponent user={rootTeamMember} /> */}
        </div>
        <div>
          <GoUpArrowButton />
          <GoRightDownArrowButton />
        </div>
      </FlexAround>

      <ZeroLevelInfo isOpen={isOpen} teamMember={rootTeamMember} />
    </>
  );
};
